import { Column } from "react-table";
import moment from "moment";
import { convertWeight, formatWeight } from "helpers/commonHelpers";
import { UnitSystemPreferences } from "types/Common";
import { FormattedMessage } from "react-intl";

const getOrderSelectionColumns = ({
  handleQRClick,
  unit_system_preferences,
}: {
  handleQRClick: (e: any, referenceNumber: string) => void;
  unit_system_preferences: UnitSystemPreferences;
}): Column<any>[] => [
  {
    Header: "Order #",
    accessor: (row) => [row.reference_number, row.title],
    Cell: ({ value }: any) => (
      <div className="d-flex align-items-center">
        <div className="d-flex flex-column">
          <span onClick={(e: any) => handleQRClick(e, value[0])} style={{ color: "#0071CE", fontWeight: 500 }}>
            {value[0]}
          </span>
          <span className="text-nowrap" style={{ color: "#64748B" }}>
            {value[1]}
          </span>
        </div>
      </div>
    ),
    minWidth: 222,
    maxWidth: 370,
  },
  {
    Header: "Pickup date",
    id: "pickup_date",
    sortable: true,
    accessor: (row) => [row.pickup_start_date, row.pickup_end_date],
    Cell: ({ value }: any) => (
      <div>
        {moment(value[0], "YYYY-MM-DD").format("DD MMM YYYY")}
        {value[1] && ` - ${moment(value[1], "YYYY-MM-DD").format("DD MMM YYYY")}`}
      </div>
    ),
    minWidth: 222,
    maxWidth: 259,
  },
  {
    Header: "Delivery date",
    id: "delivery_date",
    sortable: true,
    accessor: (row) => [row.delivery_start_date, row.delivery_end_date],
    Cell: ({ value }: any) => (
      <div>
        {moment(value[0], "YYYY-MM-DD").format("DD MMM YYYY")}{" "}
        {value[1] && ` - ${moment(value[1], "YYYY-MM-DD").format("DD MMM YYYY")}`}
      </div>
    ),
    minWidth: 222,
    maxWidth: 259,
  },
  {
    // Header: "Weight (kg)",
    Header: (
      <span className="w-100 d-flex flex-end justify-content-end">
        <FormattedMessage id="general.weight" defaultMessage="Weight" /> (
        {unit_system_preferences === "inch-lbs" ? "lbs" : "kg"})
      </span>
    ),
    accessor: "total_weight_kg",
    sortable: true,
    Cell: ({ value }: any) => {
      const weight =
        unit_system_preferences === "inch-lbs" ? convertWeight(value, { fromUnit: "kg", toUnit: "lbs" }) : value;
      return <div className="d-flex flex-end justify-content-end">{formatWeight(weight)}</div>;
    },
    width: 148,
  },
  {
    id: "volume_m",
    Header: <span className="w-100 d-flex flex-end justify-content-end">Volume (m³)</span>,
    accessor: "total_cbm",
    sortable: true,
    Cell: ({ value }: any) => <div className="d-flex flex-end justify-content-end">{value}</div>,
    width: 116,
  },
];

export default getOrderSelectionColumns;
